import { forwardRef } from "react";
export default function forwardIconRef(render) {
    return forwardRef(render);
}
